var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d3kthmqoa)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.417 6.994-1.424-1.627.199-2.153-2.106-.478L8.983.875 7 1.727 5.017.875l-1.103 1.86-2.106.473.199 2.159L.583 6.994l1.424 1.628-.199 2.158 2.106.478 1.103 1.867L7 12.268l1.983.851 1.103-1.86 2.106-.479-.199-2.152 1.424-1.634zm-2.304.864-.327.379.046.495.105 1.138-1.598.362-.256.431-.578.98-1.038-.449L7 10.996l-.46.198-1.04.45-.577-.975-.256-.431-1.599-.362.105-1.143.047-.496-.327-.38L2.141 7l.752-.863.327-.38-.052-.501-.105-1.132 1.598-.361.257-.432.577-.98 1.038.449.467.198.46-.198 1.04-.45.577.98.256.433 1.599.361-.105 1.138-.047.496.327.379.752.857-.746.864z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.886 8.02 4.533 6.663l-.864.869 2.217 2.222 4.282-4.293-.864-.87-3.418 3.43z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0d3kthmqoa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVerified);
export default __webpack_public_path__ + "static/media/ic_verified.c39cad7870b60fd915b151cd913a5832.svg";
export { ForwardRef as ReactComponent };